module.exports = __webpack_public_path__ + "static/img/spring_tab4_selected.914dd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab4_selected.png
// module id = 363
// module chunks = 32